export const SET_HOMESEARCH = 'SET_HOMESEARCH'
export const CLEAR_HOMESEARCH = 'CLEAR_HOMESEARCH'
